import { Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { IconAutoStop } from '../../../../icons'
import { messages } from './messages'
import { styles } from './styles'

type Props = {
  hidden: boolean
}

export function AutoStopAlert(props: Props) {
  const { hidden } = props

  if (hidden) {
    return null
  }

  return (
    <div data-testid="budget-auto-stop-alert" className={styles.alertContainer}>
      <div className={styles.iconBox}>
        <IconAutoStop />
      </div>
      <Text>
        <FormattedMessage {...messages.autoStopAlert} />
      </Text>
    </div>
  )
}
